module.exports = __webpack_public_path__ + "media/assets/icons/day-cloudy-windy-272736a7b7679283d3b1b4919abf42f0.svg";